import { DirectoryPage } from '@/modules/guard';

export const Directory = () => {
  return <DirectoryPage />;
};
